@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';
@import (reference) '../shared-classes.module.less';

.top-level {
  width: 100%;
  height: 100%;
}

.account-menu-container {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  a {
    color: @app-header--account-menu-dropdown--text-color;
  }
}

.account-icon {
  margin-top: 3px;
}

.account-menu-button {
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
}

.alert-icon {
  @CircularAlertCountDecoration();
}
